import firebase from './config';
import { getAuth, getIdToken, User } from 'firebase/auth';

export const auth = getAuth(firebase);

export async function getFBToken(): Promise<string | null> {
  try {
    const token: string = await getIdToken(auth.currentUser as User);
    // console.log(token);
    return token;
  } catch (error) {
    return null;
  }
}
